<template>
    <div class="field">
        <p class="control is-expanded">
            <vue-single-select
                    v-model="userId"
                    :options="options"
                    option-label="text"
                    placeholder="Select client"
                    max-height="150px"
                    :classes="{
                        input: 'input',
                        dropdown: 'user-select-drop-down'
                    }">
            </vue-single-select>
        </p>
    </div>
</template>

<script>
    import VueSingleSelect from "vue-single-select";
    import apiUsers from './../../../../../../api/apiUsers'
    export default {
        components: {
            VueSingleSelect
        },
        data () {
            return {
                options: [],
            }
        },
        computed: {
            userId: {
                get() {
                    return this.$store.getters.getSingleCarTransferUserId
                },
                set(value) {
                    this.$store.dispatch('setSingleCarTransferUserId', value)
                }
            }
        },
        methods: {
            setSelectOptions (users) {
                let list = []

                 users.forEach(function(element) {
                     list.push({
                         id: element.id,
                         text: element.name
                     })
                 })

                this.options = list
            }
        },
        created() {
            apiUsers
                .requestAllUsers()
                .then((response) => {
                    this.setSelectOptions(response.data)
                })
                .catch((error) => {
                    console.log(error)
                })
        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Cars/Car/Details/TransferCar/Inputs/UserSelect.vue